import React from 'react'
import { TEMPLATE_NOTES } from 'data/filters/types'

import { ExpandableRowLayout } from '../ExpandableRowLayout'

const TemplatesIcon = TEMPLATE_NOTES.get('icon')
const icon = <TemplatesIcon size={14} />

export const TEMPLATE_NOTES_SECTION_ID = 'templates-section-id'

export type TemplatesFilterProps = {
  isActive: boolean
  isExpanded: boolean
  onToggleExpand: (
    filterId: string,
    options?: { collapseChannels?: boolean }
  ) => void
}

export const TemplatesFilter = ({
  isActive,
  isExpanded,
  onToggleExpand,
}: TemplatesFilterProps) => (
  <ExpandableRowLayout
    id={TEMPLATE_NOTES_SECTION_ID}
    isExpanded={isExpanded}
    onToggleExpand={onToggleExpand}
    hideChevron
    depth={0}
    icon={icon}
    label={TEMPLATE_NOTES.get('name')}
    isActive={isActive}
    sticky
  />
)
